import $axios from "../../api";

// const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

const state = () => ({
  isLoading: false,
  isSuccess: false,
  errors: [],
  page: 1,
  list: {},
})

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
}

const actions = {
  async getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    try {
      const { data } = await $axios.get(`hr/attendance/approval/izin/list`, {
        params: {
          page: state.page,
          view: rootState.page,
          checkbox_retail: payload?.checkbox_retail,
          checkbox_toko: payload?.checkbox_toko,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc
        }
      });

      commit("SET_SUCCESS", true)
      commit("SET_LIST", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", "Something went wrong, please try again later", { root: true })
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async approval({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    try {
      await $axios.put(`hr/attendance/approval/izin/update-approval/${payload.inputid}`, {
        approve1: payload?.approve1,
        approve2: payload?.approve2,
      });
    } catch (error) {
      dispatch("Main/globalSweetAlert", "Something went wrong, please try again later", { root: true })
    } finally {
      commit("SET_LOADING", false);
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
};